import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:cash-multiple',
      order: 90,
      title: '客户流水',
    },
    name: 'AdCustomerFlow',
    path: '/customer-flow',
    children: [
      {
        name: 'AdOnlineRecharge',
        path: '/online-recharge',
        component: () =>
          import('#/views/customer-flow/online-recharge/index.vue'),
        meta: {
          icon: 'mdi:attach-money',
          title: '在线充值',
          keepAlive: true,
        },
      },
      {
        name: 'AdOfflineTransfer',
        path: '/offline-transfer',
        component: () =>
          import('#/views/customer-flow/offline-transfer/index.vue'),
        meta: {
          icon: 'mdi:money-off',
          title: '线下转账',
          keepAlive: true,
        },
      },
      {
        name: 'AdTransactionDetail',
        path: '/transaction-detail',
        component: () =>
          import('#/views/customer-flow/transaction-detail/index.vue'),
        meta: {
          icon: 'mdi:file-transfer-outline',
          title: '交易明细',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
